import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams, AlertController, LoadingController, App} from "ionic-angular";
import { RestProvider } from "../../providers/rest/rest";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { FileWriter } from "@ionic-native/file";
import { MATERIAL_LIST } from "../../environments/environment";
import { UploadPage } from "../upload/upload";
import { StylesCompileDependency } from "@angular/compiler";
// import { Font, TextGeometry } from 'threejs-full-es6';
// import FontJson from './helvetiker_bold.typeface.json';

// import { ViewerOptions, ViewerInitializedEvent, DocumentChangedEvent, SelectionChangedEventArgs, ThumbnailOptions, Extension } from 'ng2-adsk-forge-viewer';
// import { TestExtension } from './test-extension';
// import { SelectionExtension } from "./selection-extension";
declare var Autodesk: any, viewer: any, jQuery: any, ViewingApplication: any, viewerApp: any, viewType: any, viewables: any, material_list: any, docC: any;

/**
 * Generated class for the ViewerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-viewer",
  templateUrl: "viewer.html",
})
export class ViewerPage {
  /*public viewerOptions3d: ViewerOptions;
  public viewerOptions2d: ViewerOptions;
  public thumbnailOptions: ThumbnailOptions;
  public documentId: string;*/
  public view: number = 1;
  loading;
  public data = localStorage.getItem('outputFileNameOSS');
  

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public rest: RestProvider,
    public http: HttpClient,
    public app: App,
    public loadingController: LoadingController, 
    public AlertController: AlertController 
    
  ) {}

  ionViewDidLoad() {
    console.log("ionViewDidLoad ViewerPage");
    /*this.thumbnailOptions = {
      getAccessToken: (onGetAccessToken: (token: string, expire: number) => void) => {
        const expireTimeSeconds = 60 * 30;
        onGetAccessToken(localStorage.getItem("accessToken"), expireTimeSeconds);
      },
      documentId: localStorage.getItem("urn"),
      width: 400,
      height: 400,
      // defaultImageSrc: '',
    };

    this.viewerOptions3d = {
      initializerOptions: {
        env: 'AutodeskProduction',
        getAccessToken: (onGetAccessToken: (token: string, expire: number) => void) => {
          const expireTimeSeconds = 60 * 30;
          onGetAccessToken(localStorage.getItem("accessToken"), expireTimeSeconds);
        },
        api: 'derivativeV2',
      },
      viewerConfig: {
        extensions: [TestExtension.extensionName, SelectionExtension.extensionName],
        theme: 'bim-theme',
      },
      onViewerScriptsLoaded: this.scriptsLoaded,
      onViewerInitialized: this.loadDocument,
      // showFirstViewable: false,
      // headlessViewer: true,
    };

    this.viewerOptions2d = Object.assign({}, this.viewerOptions3d, { showFirstViewable: false });*/
    if(this.navParams.get('view')) {
      this.view = this.navParams.get('view');
    }
    if(localStorage.getItem('viewType') == null) {
      viewType = this.view;  
    } else {
      viewType = parseInt(localStorage.getItem('viewType'));
    }
      
    material_list = MATERIAL_LIST;
    // docC = 'urn:' + localStorage.getItem('urn');
    this.getLoadUrn();
    this.presentLoadingWithOptions();
  }

  getLoadUrn() {
    this.rest.getLoadUrn(localStorage.getItem('urn')).subscribe(async res => {
      

      if(res.status == 'success') {
        this.stopLoading();
        if(localStorage.getItem('saving') == 'saved'){
          
          this.presentAlert();
          localStorage.removeItem('saving');
        }
        var documentId = 'urn:' + localStorage.getItem('urn');
        
        var options = {
          env: 'AutodeskProduction',
          language: 'jp',
          api: 'derivativeV2', // TODO: for models uploaded to EMEA change this option to 'derivativeV2_EU'
          accessToken: this.getAccessToken()
          // enableArcs: true
        };
        var config3d = {
          extensions: ['MyAwesomeColor', 'MyAwesomeExtension', 'DemoMenuExtension', 'MySelectionWindow', 'EventsTutorial', //ToolbarExtension
          'Autodesk.Sample.Navigator'] // , 'MyAwesomeShape' , 'Autodesk.Edit2D' , 'Autodesk.DocumentBrowser'
        };




        Autodesk.Viewing.Initializer(options, async function onInitialized(){
          // Autodesk.Viewing.endpoint.HTTP_REQUEST_HEADERS = {
          //   "If-Modified-Since": "Sat, 29 Oct 2020 19:43:31 GMT"
          // };
          viewerApp = new Autodesk.Viewing.ViewingApplication('MyViewerDiv');
          viewerApp.registerViewer(viewerApp.k3D, Autodesk.Viewing.Private.GuiViewer3D, config3d);
          Autodesk.Viewing.endpoint.HTTP_REQUEST_HEADERS = {
            'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
            'If-Modified-Since' : 'Sat, 29 Oct 1994 19:43:31 GMT'
          };
          viewerApp.loadDocument(documentId,
            (window as any).onDocumentLoadSuccess,
            (window as any).onDocumentLoadFailure);
          // Autodesk.Viewing.Document.load(documentId, (window as any).onDocumentLoadSuccess, (window as any).onDocumentLoadFailure);
          var htmlElement = document.getElementById('MyViewerDiv');
          if (htmlElement) {          
              // Create and start the viewer in that element
              
              viewer = new Autodesk.Viewing.GuiViewer3D(htmlElement, config3d);
              viewer.start();
              // Load the document into the viewer.
              Autodesk.Viewing.Document.load(documentId, (window as any).onDocumentLoadSuccess, (window as any).onDocumentLoadFailure);
          }

        });

      } else if(res.status == 'failed') {
        var documentId = 'urn:' + localStorage.getItem('urn');
        var options = {
          env: 'AutodeskProduction',
          language: 'jp',
          api: 'derivativeV2', // TODO: for models uploaded to EMEA change this option to 'derivativeV2_EU'
          accessToken: this.getAccessToken()
        };
        var config3d = {
          extensions: ['MyAwesomeColor', 'MyAwesomeExtension', 'DemoMenuExtension', 'MySelectionWindow', 'EventsTutorial', //ToolbarExtension
          'Autodesk.Sample.Navigator', 'Autodesk.Edit2D']
        };
        console.log('2');
        Autodesk.Viewing.Initializer(options, function onInitialized(){
          // viewerApp = new Autodesk.Viewing.ViewingApplication('MyViewerDiv');
          // viewerApp.registerViewer(viewerApp.k3D, Autodesk.Viewing.Private.GuiViewer3D, config3d);
          // Autodesk.Viewing.endpoint.HTTP_REQUEST_HEADERS = {
          //   'Authorization': 'Bearer ' + localStorage.getItem('accessToken'),
          //   'If-Modified-Since' : 'Sat, 29 Oct 1994 19:43:31 GMT'
          // };
          // viewerApp.loadDocument(documentId,
          //   (window as any).onDocumentLoadSuccess,
          //   (window as any).onDocumentLoadFailure);
          // Autodesk.Viewing.Document.load(documentId, (window as any).onDocumentLoadSuccess, (window as any).onDocumentLoadFailure);
          var htmlElement = document.getElementById('MyViewerDiv');
          if (htmlElement) {
              // Create and start the viewer in that element
              
              viewer = new Autodesk.Viewing.GuiViewer3D(htmlElement, config3d);
              viewer.start();
              // Load the document into the viewer.
              Autodesk.Viewing.Document.load(documentId, (window as any).onDocumentLoadSuccess, (window as any).onDocumentLoadFailure);
          }
        });
        this.stopLoading();
      } else {
        this.getLoadUrn();
      }
    }, err => {
      this.stopLoading();
      var nav = this.app.getRootNavs();
      nav[0].setRoot(UploadPage);
    });
  }
  
  onDocumentLoadSuccess(doc) {
    // Load the default viewable geometry into the viewer.
    // Using the doc, we have access to the root BubbleNode,
    // which references the root node of a graph that wraps each object from the Manifest JSON.

    


    if(viewType == 2) {
      viewables = viewerApp.bubble.search({'type':'geometry', 'role': '2d'});
    } else {
      viewables = viewerApp.bubble.search({'type':'geometry'});
    }
    // console.log(viewables);
    // viewerApp.selectItem(
    //   viewables[0].data, 
    //   (window as any).onItemLoadSuccess, 
    //   (window as any).onItemLoadFail);
    var viewable = doc.getRoot().getDefaultGeometry();
    if (viewable) {
        viewer.loadDocumentNode(doc, viewable).then(function(result) {
            console.log('Viewable Loaded!');
        }).catch(function(err) {
            console.log('Viewable failed to load.');
            console.log(err);
        }
      )
    }
  }

  /**
  * Autodesk.Viewing.Document.load() failure callback.
  */
  onDocumentLoadFailure(viewerErrorCode) {
      console.error('onDocumentLoadFailure() - errorCode: ' + viewerErrorCode);
      jQuery('#MyViewerDiv').html('<p>Translation in progress... Please try refreshing the page.</p>');
  
  }

  /*public scriptsLoaded() {
    Extension.registerExtension(TestExtension.extensionName, TestExtension);
    Extension.registerExtension(SelectionExtension.extensionName, SelectionExtension);
  }
  
  public loadDocument(args: ViewerInitializedEvent) {
    args.viewerComponent.DocumentId = localStorage.getItem("urn");
  }
  
  public documentChanged(event: DocumentChangedEvent) {
    const { document } = event;
    
    if (!document.getRoot()) return;
    
    const viewables = document.getRoot().search({ type: 'geometry', role: '2d' });
    console.log(1,viewables);
    if (viewables && viewables.length > 0) {
      event.viewerComponent.loadDocumentNode(document, viewables[0]);
    }
    

  }
  
  public selectionChanged(event: SelectionChangedEventArgs) {
    console.log(event);
  }*/
  
  containerId() {    
    console.log(4);
    this.rest.getHubs().subscribe(
      res => {
        console.log(123,res);
      }
      )
  }
  
  geometobjectTreeCreated(evt) {
    console.log(5);
    //load the extension MySelectionWindow and call initialization 
    // this.viewer.loadExtension('MySelectionWindow').then(function(ext){ 
      //     ext.init();  
      // }); 
  }

  getAccessToken() {
    return localStorage.getItem('accessToken');
  }

  uploadPythonSample() {
    this.rest.translateObject(localStorage.getItem('urn')).subscribe((res) => {      
      localStorage.setItem('urn', res.urn);
      this.navCtrl.push(ViewerPage, { urn: res.urn });
    });
  }
  
  async presentAlert() {
    const alert = await this.AlertController.create({
      cssClass: 'my-custom-class',
      message: '反映処理が完了しました。',
      buttons: ['はい']
    });

    await alert.present();
  }

  async presentLoadingWithOptions() {
    this.loading = await this.loadingController.create({
      spinner: null,
      content: 'お待ちください...',
      cssClass: 'custom-class custom-loading'
    });
    return await this.loading.present();
  }
  
  async stopLoading() {
    return await this.loading.dismiss();
  }
    
  //   let appPackagePath = '../bundles/';
  //   let modelfilePath = './sample files/';

  //   let desired_nickname = 'susanolikename';

  //   let alias = '23';

  //   let TIMEOUT = 10 * 60;

  //   let width = 100;
  //   let height = 100;

  //   // let parser = argparse.ArgumentParser(description = 'Demo Workflow of Design Automation. Input Updated Height and Width:');
  //   // parser.add_argument('--height', required = true);
  //   // parser.add_argument('--width', required = true);
  //   // let args = parser.parse_args();
  //   // width = args.width;
  //   // height = args.height;
  //   // DOORHI NI PACKAGE UUDAA SONGODOG HESEG 
  //   // let file_list = os.listdir(appPackagePath);
  //   // let index = 0;
  //   // file_list.forEach(bundle => console.log( '[' + index + ']' + bundle ));

  //   let zip_name = 'UpdateRVTParam.zip';

  //   let appboundle_name = 'UpdateRVTParam';

  //   let activity_name = appboundle_name;

  //   let nickname = 'SUSANO';

  //   let enginename;
  //   let engines = this.rest.dumpEngines().subscribe(engines => {
  //     console.log(engines);
  //     enginename = engines.data[0];
  //   });
  //   enginename = 'Autodesk.Revit+2020'; // TODO engine NAME iig garaas avch baina 

  //   // 4.CREATE/UPDATE APP BUNDLE
  //   let qualifiedAppBundleId = nickname + '.' + appboundle_name + '+' + alias;
  //   let findApp = false;

  //   let appbubdles = this.rest.getDefinedAppbundles(0).subscribe(bundles => {
  //     bundles.data.forEach(element => {
  //       console.log('BUND: ' + element);
  //       if(qualifiedAppBundleId == element) {
  //         findApp = true;
  //       }
  //     });
  
  //     if(findApp) {
  //       console.log('---App bundle already defined:' + qualifiedAppBundleId)
  //       console.log('---Creating new version of app bundle...');
  //       this.rest.createAppBundleVersion(enginename, appboundle_name).subscribe(cbund => {
  //         /*this.rest.uploadZip(appboundle_name,zip_name,cbund['uploadParameters']['formData']).subscribe(zip => {
  //           if(zip == null) {
  //             console.log("Api amjiltgui hariu irlee");
  //           } else {*/
  //             this.rest.updateAppBundleAlias(appboundle_name,alias,cbund['version']).subscribe(aliass => {
  //               if(aliass == null) {
  //                 console.log("Api amjiltgui hariu irlee");
  //               }
  //               console.log('***New app bundle version is created...' + qualifiedAppBundleId + ' version=' + cbund['version']);

  //               // 5.CREATE ACTIVITY
  //               let qualifiedActivityId = nickname + '.' + activity_name + '+' + alias;
  //               let findAct = false;
  //               this.rest.getDefinedActivities().subscribe(activities => {
  //                 activities.data.forEach(element => {
  //                   console.log(' ' + element);
  //                   if(qualifiedActivityId == element) {
  //                     findAct = true;
  //                     this.rest.deleteActivity(qualifiedActivityId).subscribe(act => {

  //                     });
  //                   }
  //                 });
  //                 if(findAct) {
  //                   console.log('***Activity already defined:', qualifiedActivityId);
  //                 } else {
  //                   console.log('---Creating activity...');
  //                   this.rest.createActivity(enginename,appboundle_name,qualifiedAppBundleId,activity_name).subscribe(active => {
  //                     if (active == null) {
  //                       console.log("Api amjiltgui hariu irlee");
  //                     } else {
  //                       this.rest.createActivityAlias(activity_name, alias).subscribe(alias => {
  //                         if(alias == null) {
  //                           console.log("Api amjiltgui hariu irlee");
  //                         } else {
  //                           // 7.CREATE WORKITEM
  //                           let param = {};
  //                           param['bucketKey'] = this.rest.getBucket();
  //                           param['inputFileNameOSS'] = 'zoloo_shine_sheettei.rvt';
  //                           param['jsonInput'] = [];
  //                           param['jsonInput']['width'] = width;
  //                           param['jsonInput']['height'] = height;
  //                           this.rest.createWorkItem(activity_name, param).subscribe(work => {
  //                             if(work == null) {
  //                               console.log("Api amjiltgui hariu irlee");
  //                             } else {
  //                               let workItemId = work['id'];
  //                               let ossOutputUrl = work['ossOutputUrl'];
  //                               let outputFileNameOSS = work['outputFileNameOSS'];
    
  //                               // 8.CHECK WORKITEM STATUS AND DOWNLOAD RESULT/REPORT
  //                               let status = 'pending';
  //                               console.log('---work item running!');
  //                               let start_time = new Date().getTime();
  //                               let statusResponse;
  //                               while( status == 'pending ' || status == 'inprogress') {
  //                                 this.rest.getWorkItemStatus(workItemId).subscribe(statusResponse => {
  //                                   if(statusResponse == null) {
  //                                     console.log("Api amjiltgui hariu irlee");
  //                                   }
  //                                   status = statusResponse['status'];
  //                                   if(status != 'pending' && status != 'inprogress') {
  //                                     // 9.GET OUTPUT FILE OR LOG FILE     
  //                                     if(status == 'success') {
  //                                       console.log('--- downloading output file: ', outputFileNameOSS);
  //                                       this.http
  //                                         .get(ossOutputUrl, {headers: {'Authorization': 'Bearer ' + this.getAccessToken()}}).subscribe(response => {                                            
  //                                           // this.file.writeFile('C:\Users\User\Desktop', 'xaxa', response['content'], {replace: true, append: false});
  //                                           console.log(response['content']);
  //                                           console.log('get output file succeeded: ' + outputFileNameOSS );                                            
  //                                         });                                        
  //                                     } else {
  //                                       console.log('---downloading report file: ' + workItemId + '.log');
  //                                       let reportUrl = statusResponse['reportUrl'];
  //                                       let response = this.http
  //                                         .get(reportUrl);
  //                                         // this.file.writeFile('C:\Users\User\Desktop', 'log', response['content'], {replace: true, append: false})
  //                                         console.log('get log file succeeded: ' + response['content']);
  //                                     }
  //                                   }
  //                                   let elapsed_time = new Date().getTime() - start_time;
  //                                   if(elapsed_time > TIMEOUT) {
  //                                     console.log('     get work item status timeout!');
  //                                   }
  //                                 });                                  
  //                               }    
  //                               console.log('****work item status: ', status);
  //                             }
  //                           });                            
  //                         }
  //                       });                      
  //                     }                      
  //                   });                    
  //                 }
  //               });
                
  //             });              
  //           /*}
  //         });  */        
  //       });  
  //     } else {
  //       this.rest.createAppBundle(enginename,appboundle_name).subscribe(cbund => {
  //         console.log('newAppRes =>', cbund);
  //         console.log('zip_name => ', zip_name);
  //         console.log('cbund => ', cbund['uploadParameters']['formData']);
  //         console.log('cbund => ', cbund);
  //         this.rest.uploadZip(appboundle_name,zip_name,cbund['uploadParameters']['formData']).subscribe(zip => {
  //           console.log('uploadRes => ', zip);
  //           this.rest.createAppBundleAlias(appboundle_name, alias, 1).subscribe(aliass => {
  //             console.log('aliasRes => ', aliass);
  //             if(aliass == null) {
  //               console.log("Api amjiltgui hariu irlee");
  //             }
  //             console.log('***New app bundle version is created...' + qualifiedAppBundleId + ' version=' + cbund['version']);

  //             // 5.CREATE ACTIVITY
  //             let qualifiedActivityId = nickname + '.' + activity_name + '+' + alias;
  //             let findAct = false;
  //             this.rest.getDefinedActivities().subscribe(activities => {
  //               activities.data.forEach(element => {
  //                 console.log(' ' + element);
  //                 if(qualifiedActivityId == element) {
  //                   findAct = true;
  //                 }
  //               });
  //               if(findAct) {
  //                 console.log('***Activity already defined:', qualifiedActivityId);
  //               } else {
  //                 console.log('---Creating activity...');
  //                 this.rest.createActivity(enginename,appboundle_name,qualifiedAppBundleId,activity_name).subscribe(active => {
  //                   if (active == null) {
  //                     console.log("Api amjiltgui hariu irlee");
  //                   } else {
  //                     this.rest.createActivityAlias(activity_name, alias).subscribe(alias => {
  //                       if(alias == null) {
  //                         console.log("Api amjiltgui hariu irlee");
  //                       } else {
  //                         // 7.CREATE WORKITEM
  //                         let param = {};
  //                         param['bucketKey'] = this.rest.getBucket();
  //                         param['inputFileNameOSS'] = 'zoloo_shine_sheettei.rvt';
  //                         param['jsonInput'] = [];
  //                         param['jsonInput']['width'] = width;
  //                         param['jsonInput']['height'] = height;
  //                         this.rest.createWorkItem(activity_name, param).subscribe(work => {
  //                           if(work == null) {
  //                             console.log("Api amjiltgui hariu irlee");
  //                           } else {
  //                             let workItemId = work['id'];
  //                             let ossOutputUrl = work['ossOutputUrl'];
  //                             let outputFileNameOSS = work['outputFileNameOSS'];
  
  //                             // 8.CHECK WORKITEM STATUS AND DOWNLOAD RESULT/REPORT
  //                             let status = 'pending';
  //                             console.log('---work item running!');
  //                             let start_time = new Date().getTime();
  //                             let statusResponse;
  //                             while( status == 'pending ' || status == 'inprogress') {
  //                               this.rest.getWorkItemStatus(workItemId).subscribe(statusResponse => {
  //                                 if(statusResponse == null) {
  //                                   console.log("Api amjiltgui hariu irlee");
  //                                 }
  //                                 status = statusResponse['status'];
  //                                 if(status != 'pending' && status != 'inprogress') {
  //                                   // 9.GET OUTPUT FILE OR LOG FILE     
  //                                   if(status == 'success') {
  //                                     console.log('--- downloading output file: ', outputFileNameOSS);
  //                                     this.http
  //                                       .get(ossOutputUrl, {headers: {'Authorization': 'Bearer ' + this.getAccessToken()}}).subscribe(response => {                                            
  //                                         // this.file.writeFile('C:\Users\User\Desktop', 'xaxa', response['content'], {replace: true, append: false});
  //                                         console.log(response['content']);
  //                                         console.log('get output file succeeded: ' + outputFileNameOSS );                                            
  //                                       });                                        
  //                                   } else {
  //                                     console.log('---downloading report file: ' + workItemId + '.log');
  //                                     let reportUrl = statusResponse['reportUrl'];
  //                                     let response = this.http
  //                                       .get(reportUrl);
  //                                       // this.file.writeFile('C:\Users\User\Desktop', 'log', response['content'], {replace: true, append: false})
  //                                       console.log('get log file succeeded: ' + response['content']);
  //                                   }
  //                                 }
  //                                 let elapsed_time = new Date().getTime() - start_time;
  //                                 if(elapsed_time > TIMEOUT) {
  //                                   console.log('     get work item status timeout!');
  //                                 }
  //                               });                                  
  //                             }    
  //                             console.log('****work item status: ', status);
  //                           }
  //                         });                            
  //                       }
  //                     });                      
  //                   }                      
  //                 });                    
  //               }
  //             });
  //           });            
  //         });          
  //       });        
  //     }
  //   }); 

}



// WEBPACK FOOTER //
// ./src/pages/viewer/viewer.ts